import {persistState, PersistStateSelectFn, Query, selectPersistStateInit, Store, StoreConfig} from "@datorama/akita"
import produce from "immer"
import Logger from "logger/logger"
import {akitaCypressQueryBinding, akitaCypressStoreBinding} from "utils/akitaCypressBinding"
import {onEmit} from "utils/onEmit"

interface AuthStoreProps {
  loading: boolean | undefined
  isAuthenticated: boolean
  isUpdatingToken: boolean
  token: string | undefined
}

@StoreConfig({name: `auth`, resettable: true, producerFn: produce})
export class AuthStore extends Store<AuthStoreProps> {
  constructor() {
    super({
      loading: undefined,
      isAuthenticated: false,
      isUpdatingToken: false,
      token: ''
    })
    Logger('Store.Auth', 'init')
    akitaCypressStoreBinding(this)
    onEmit(selectPersistStateInit(), () => {
      Logger('Store.Auth', 'read from localStore')
      this.update(state => {
        state.loading = false
      })
    })

  }
}

class AuthQuery extends Query<AuthStoreProps> {
  constructor(protected store: AuthStore) {
    super(store)
    akitaCypressQueryBinding(this)
  }
}

// Create persistent storage on browser
const authSelectToken: PersistStateSelectFn<AuthStoreProps> = (state) => ({
  token: state.token,
  isAuthenticated: state.isAuthenticated,
})
authSelectToken.storeName = "auth"

export const rootAuthPersistedStorage = persistState({
  key: 'sticky.auth',
  include: [`auth`],
  select: [authSelectToken],
})

export const rootAuthStore = new AuthStore()
export const authQuery = new AuthQuery(rootAuthStore)
